import React from "react";
import { ReactComponent as ErrorRobotLamp } from "resources/icons/ErrorLampRobot.svg";
import { ReactComponent as RegenerateIcon } from "resources/icons/Regenerate.svg";
import { ReactComponent as NovaIcon } from "resources/icons/nova.svg";
const RegenerateAiResponse = ({
  isAiLoading,
  regenerateCurrentResponse,
  userMessageId,
}) => {
  return (
    <>
      <div className="flex flex-col align-center mt-20 mb-30">
        {!isAiLoading && <NovaIcon className="nova-regenerate-icon" />}
        <ErrorRobotLamp />
        <span className="fs-smedium fw-500 regenerate-response-text">
          An error occurred while generating the response
        </span>
        <div
          className="fs-smedium fw-500 cursor-pointer regenerate-response-button flex items-center justify-center gap-2"
          onClick={() => regenerateCurrentResponse({ userMessageId })}
        >
          <RegenerateIcon className="mb-1" />
          <div className="position-relative regenerate-icon-text">
            Regenerate
          </div>
        </div>
      </div>
    </>
  );
};

export default RegenerateAiResponse;
